import api from "../api";
import { JEWELLERY_API_ENDPOINTS } from "../../constants/jewellery.constant";

// Helper function to replace path params
const replacePathParams = (path, params) => {
  let result = path;
  Object.keys(params).forEach((key) => {
    result = result.replace(`:${key}`, params[key]);
  });
  return result;
};

const templateService = {
  // Create template
  createTemplate: async (templateData) => {
    const response = await api.post(
      JEWELLERY_API_ENDPOINTS.CREATE_TEMPLATE,
      templateData
    );
    return response.data;
  },

  // Get all templates
  getAllTemplates: async (filters = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.GET_TEMPLATES, {
      params: filters,
    });
    return response.data;
  },

  // Get template by ID
  getTemplateById: async (templateId) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.GET_TEMPLATE, {
      id: templateId, // ✅ Changed from templateId to id
    });
    const response = await api.get(url);
    return response.data;
  },

  // Update template
  updateTemplateById: async (templateId, templateData) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.UPDATE_TEMPLATE, {
      id: templateId, // ✅ Changed from templateId to id
    });
    const response = await api.put(url, templateData);
    return response.data;
  },

  // Delete template
  deleteTemplateById: async (templateId) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.DELETE_TEMPLATE, {
      id: templateId, // ✅ Changed from templateId to id
    });
    const response = await api.delete(url);
    return response.data;
  },
};

export default templateService;
